module.exports = __webpack_public_path__ + "static/media/bring.cee59262.png";